import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoadingComplete, LoadingStart } from '../state/loading';
import { Loading } from './loading.decorator';

@Injectable({
  providedIn: 'root',
})
export class WrapperHttpService {
  loading = false;
  wrappedHttpLoading: WrapperHttpService;
  count = 0;

  constructor(private http: HttpClient, private store: Store) {}

  withLoading(): WrapperHttpService {
    this.loading = true;

    if (this.wrappedHttpLoading) {
      return this.wrappedHttpLoading;
    }
    this.wrappedHttpLoading = new WrapperHttpService(this.http, this.store);
    this.wrappedHttpLoading.loading = true;
    return this.wrappedHttpLoading;
  }

  @Loading
  get<T>(url: string, options?: object): Observable<T> {
    return this.http.get<T>(url, options);
  }

  @Loading
  post<T>(url: string, body: unknown, options?: object): Observable<T> {
    return this.http.post<T>(url, body, options);
  }

  @Loading
  put<T>(url: string, body: unknown, options?: object): Observable<T> {
    return this.http.put<T>(url, body, options);
  }

  @Loading
  patch<T>(url: string, body: unknown, options?: object): Observable<T> {
    return this.http.patch<T>(url, body, options);
  }

  @Loading
  delete<T>(url: string, options?: object): Observable<T> {
    return this.http.delete<T>(url, options);
  }

  private startLoading(): void {
    if (this.count === 0) {
      this.store.dispatch(new LoadingStart());
    }
    this.count++;
  }

  private completeLoading(): void {
    if (this.count > 0) {
      this.count--;
    }
    if (this.count === 0) {
      this.store.dispatch(new LoadingComplete());
    }
  }
}
